import { FormBase } from "../util/form-base-form";
import { Roles } from "../constants/roles";

const CARD_SELECTOR = ".admin-download-card";

/**
 * DOM accessors for the shared admin export form (ISS-08-015 async layer). The
 * form is a GET form whose per-card submit buttons still carry a streaming
 * `formaction` as the no-JS fallback; this class only exposes what the async
 * listener/handler need to intercept a submit and target the right card.
 */
export class ExportAsyncForm extends FormBase {
    private readonly root: HTMLFormElement;

    public constructor(root: HTMLFormElement) {
        super();
        this.root = root;
    }

    public getFormElement(): HTMLFormElement {
        return this.root;
    }

    public isInitialized(): boolean {
        return this.root.dataset.exportAsyncInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.exportAsyncInit = "1";
    }

    public getCardFromSubmitter(submitter: Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(submitter, CARD_SELECTOR, HTMLElement);
    }

    public getStatusBoxInCard(card: ParentNode): HTMLElement | null {
        return this.queryElement(card, `[data-role="${Roles.EXPORT_STATUS}"]`, HTMLElement);
    }

    public getSubmitButtonInCard(card: ParentNode): HTMLButtonElement | null {
        return this.queryElement(card, 'button[type="submit"]', HTMLButtonElement);
    }

    /**
     * Serialise every control in the form to a flat params object. Duplicate
     * names (the hidden `xlsx`/`0` fallbacks paired with the toggle controls)
     * collapse to the last value, mirroring how a query string would parse.
     */
    public collectParams(): Record<string, string> {
        const params: Record<string, string> = {};
        for (const [key, value] of new FormData(this.root).entries()) {
            if (typeof value === "string") {
                params[key] = value;
            }
        }
        return params;
    }
}
